module.exports = __webpack_public_path__ + "img/blue-calendar.7d6b7323.svg";